import { v4 as uuidv4 } from 'uuid';

export default class ConsultaService {


  enviaConsulta(consulta, token) {

      const uuid = uuidv4();

       //URL PRO: https://ws148.juntadeandalucia.es/consultas-sae/csae/consultas/
       //URL PRE: https://ws158.juntadeandalucia.es/consultas-sae/csae/consultas/
       //URL docker: http://10.188.31.201:8090/csae/consultas/
       //URL local: http://localhost:8090/consultas/
             
      return fetch(CONSULTAS_BACKEND_HOST + uuid , {
            method: 'PUT', // *GET, POST, PUT, DELETE, etc.
            mode: 'cors', // no-cors, *cors, same-origin
            cache: 'no-cache', // *default, no-cache, reload, force-cache, only-if-cached
            credentials: 'same-origin', // include, *same-origin, omit
            headers: {
              'Content-Type': 'application/json',
              'Authorization': token
            },
            redirect: 'follow', // manual, *follow, error
            referrerPolicy: 'no-referrer', // no-referrer, *no-referrer-when-downgrade, origin, origin-when-cross-origin, same-origin, strict-origin, strict-origin-when-cross-origin, unsafe-url
            body: JSON.stringify(consulta) // body data type must match "Content-Type" header
          });
  }

  enviaConsultaConFicheroAdjunto(consulta, file, token) {

    var formdata = new FormData();
    formdata.append("file", file);
    formdata.append("consulta",new Blob([JSON.stringify(consulta)], {type: 'application/json'}));


     var requestOptions = {
      method: 'PUT', // *GET, POST, PUT, DELETE, etc.
      mode: 'cors', // no-cors, *cors, same-origin
      cache: 'no-cache', // *default, no-cache, reload, force-cache, only-if-cached
      credentials: 'same-origin', // include, *same-origin, omit
      headers: {
       'Authorization': token
      },
      redirect: 'follow', // manual, *follow, error
      referrerPolicy: 'no-referrer',
      body: formdata
    };
     
    const uuid = uuidv4();

    return fetch(CONSULTAS_BACKEND_HOST + uuid, requestOptions);
  }

  reabreConsulta(consulta, token) {

    return fetch(REABRIR_BACKEND_HOST , {
          method: 'POST', // *GET, POST, PUT, DELETE, etc.
          mode: 'cors', // no-cors, *cors, same-origin
          cache: 'no-cache', // *default, no-cache, reload, force-cache, only-if-cached
          credentials: 'same-origin', // include, *same-origin, omit
          headers: {
            'Content-Type': 'application/json',
            'Authorization': token
          },
          redirect: 'follow', // manual, *follow, error
          referrerPolicy: 'no-referrer', // no-referrer, *no-referrer-when-downgrade, origin, origin-when-cross-origin, same-origin, strict-origin, strict-origin-when-cross-origin, unsafe-url
          body: JSON.stringify(consulta) // body data type must match "Content-Type" header
        });
  }


  reabreConsultaConFicheroAdjunto(consulta, file, token) {

    var formdata = new FormData();
    formdata.append("file", file);
    formdata.append("consulta",new Blob([JSON.stringify(consulta)], {type: 'application/json'}));
   
    return fetch(REABRIR_BACKEND_HOST , {
          method: 'POST', // *GET, POST, PUT, DELETE, etc.
          mode: 'cors', // no-cors, *cors, same-origin
          cache: 'no-cache', // *default, no-cache, reload, force-cache, only-if-cached
          credentials: 'same-origin', // include, *same-origin, omit
          headers: {
            'Authorization': token
          },
          redirect: 'follow', // manual, *follow, error
          referrerPolicy: 'no-referrer', // no-referrer, *no-referrer-when-downgrade, origin, origin-when-cross-origin, same-origin, strict-origin, strict-origin-when-cross-origin, unsafe-url
          body: formdata // body data type must match "Content-Type" header
        });
  }

}